export const iconFontAwesomeSciencefictionJedi = (
	<i className="fa-solid fa-jedi"></i>
);
